export enum EstadoTanqueUnico {
    EnServicio,
    FueraServicio,
    LimpiezaInspeccion,
    FueraDeEspecificacion,
    EnAnalisis,
    Desvinculado
}